import { getVisitInfo } from '@ucheba/utils/hooks/useVisitsTracker'
import { SCHOOL_SITE_NAME } from '@ucheba/utils/constants/core'
import { useEffect, useState } from 'react'
import { useEdPartnersClickId } from '../../src/components/AppliactionForm/bll'

interface IShowPhoneAndMessengers {
  (): boolean
}

export const useShowPhoneAndMessengers: IShowPhoneAndMessengers = () => {
  const [lastImportantUtmSource, setLastImportantUtmSource] = useState<any>()
  const edPartnersClickId = useEdPartnersClickId()

  useEffect(() => {
    const { lastImportantSource } = getVisitInfo(SCHOOL_SITE_NAME)
    setLastImportantUtmSource(lastImportantSource?.utmSource)
  }, [])

  if (edPartnersClickId) {
    return lastImportantUtmSource && lastImportantUtmSource !== 'edpartners'
  }

  return true
}
